import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { profileScopeCacheKey, useProfileScopeQuery } from '@syf-api-library/profile';
import useConfig from '../../context/config.context';
import useSteps from '../../context/steps.context';
import queryParamsToObject from '../../helpers/queryParamsToObject';
import { Wrapper } from '../../components/MainLayout';
import { useQueryClient } from '@tanstack/react-query';
const getOtpErrorCallbackParams = () => {
    if (sessionStorage.getItem('otpErrorCallbackParams')) {
        return String(sessionStorage.getItem('otpErrorCallbackParams'));
    }
    return '';
};
export const useOTP = () => {
    const otpErrorCallbackParams = getOtpErrorCallbackParams();
    const { config, accountId } = useConfig();
    const getSelectedAccountId = () => {
        if (sessionStorage.getItem('selectedAccountId')) {
            return String(sessionStorage.getItem('selectedAccountId'));
        }
        return accountId;
    };
    const selectedAccountId = getSelectedAccountId();
    const { data, isLoading, error } = useProfileScopeQuery({
        config,
        keyProps: { accountId: selectedAccountId, accountIdType: 'guid' }
    });
    return {
        data,
        otpErrorCallbackParams,
        isLoading,
        error,
        selectedAccountId
    };
};
/* eslint-disable react/function-component-definition */
const withAuth = (View) => () => {
    const { authenticationRedirect } = useConfig();
    const { otpErrorCallbackParams, isLoading, error, selectedAccountId } = useOTP();
    const queryClient = useQueryClient();
    const { stepsDispatch } = useSteps();
    const { stepsState: { activeStep, previousSteps, answers } } = useSteps();
    useEffect(() => {
        if (!otpErrorCallbackParams) {
            return;
        }
        const { error: errorCode } = queryParamsToObject(otpErrorCallbackParams);
        if (errorCode) {
            sessionStorage.removeItem('otpErrorCallbackParams');
            stepsDispatch({ type: 'updateStep', payload: 'CantVerify' });
            /*
             * Cancel the request + set empty data so isInitialLoading for this query becomes false
             * to avoid stale state
             */
            queryClient.cancelQueries({
                queryKey: profileScopeCacheKey({
                    accountId: selectedAccountId,
                    accountIdType: 'guid'
                })
            });
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    if (isLoading) {
        return (_jsx(Wrapper, { children: _jsx(VerticalCardLoader, {}) }));
    }
    if ((error === null || error === void 0 ? void 0 : error.response.status) === 403) {
        const scope = 'read write write:sensitive profile:read:sensitive';
        const navigateTo = '/account-services';
        const modal = 'ReplacementCard';
        sessionStorage.setItem('replacement-mfe_state', JSON.stringify({ activeStep, previousSteps, answers }));
        authenticationRedirect({ scope, navigateTo, modal });
        return (_jsx(Wrapper, { children: _jsx(VerticalCardLoader, {}) }));
    }
    return _jsx(View, {});
};
export default withAuth;
//# sourceMappingURL=index.js.map